module.exports = __webpack_public_path__ + "img/w3_circle_list_black.67812b74.png";